import React from "react";
import styled from "styled-components";


const MobileHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: left;
    flex-direction: column; 
`

const MQNo = styled.p`
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0;
    margin-top: 8px;
`

const MobileHeader = (props) => (
    <div>
            <MobileHeaderWrapper>
                <MQNo>Question {props.qNo} of {props.length}</MQNo>
            </MobileHeaderWrapper>        
    </div>
)
   


export default MobileHeader;